module.exports = __webpack_public_path__ + "img/logo-white.daa7a947.svg";